import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PILLARS } from "@/data/site";
import { Eyebrow, FadeIn } from "@/components/blocks";

export default function Pillars() {
  return (
    <section data-testid="programs-overview" className="bg-bone px-6 py-28 text-ink sm:px-10 sm:py-36 lg:px-16">
      <div className="mx-auto max-w-[1440px]">
        <FadeIn>
          <Eyebrow tone="ink">The 4 Coaching Pathways</Eyebrow>
        </FadeIn>
        <FadeIn delay={0.1}>
          <h2 className="mt-8 max-w-4xl font-display text-4xl font-black uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
            One body. <span className="text-ink/40">Four pathways.</span>
          </h2>
        </FadeIn>
        <FadeIn delay={0.15}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-smoke sm:text-lg">
            Every pathway is delivered the same way — live, private 1:1 video sessions with an expert
            coach. Choose where you start.
          </p>
        </FadeIn>

        <div className="mt-20">
          {PILLARS.map((p, i) => (
            <FadeIn key={p.key} className="border-t border-ink/15 last:border-b">
              <Link
                to={p.path}
                data-testid={`pillar-link-${p.key}`}
                className="group grid items-center gap-10 py-12 sm:py-16 lg:grid-cols-2 lg:gap-20"
              >
                <div className={i % 2 === 1 ? "lg:order-2" : ""}>
                  <p className="font-mono text-xs uppercase tracking-[0.3em] text-ink/50">
                    Pathway {String(i + 1).padStart(2, "0")}
                  </p>
                  <h3 className="mt-4 font-display text-4xl font-black uppercase tracking-tight sm:text-6xl">
                    {p.title}
                  </h3>
                  <p className="mt-3 font-display text-xl font-bold uppercase tracking-tight text-ink/60 sm:text-2xl">
                    {p.tagline}
                  </p>
                  <div className="mt-7 space-y-5">
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink/45">For</p>
                      <p className="mt-1.5 max-w-md text-sm leading-relaxed text-smoke sm:text-base">{p.forWho}</p>
                    </div>
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ink/45">Delivery</p>
                      <p className="mt-1.5 max-w-md text-sm leading-relaxed text-smoke sm:text-base">{p.delivery}</p>
                    </div>
                  </div>
                  <p className="mt-8 inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em] text-ink">
                    <span className="h-px w-8 bg-lime" />
                    {p.cta}
                    <ArrowUpRight className="h-4 w-4 text-ink/40 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-lime" />
                  </p>
                </div>
                <div className={`overflow-hidden ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                  <div className="aspect-[16/10] overflow-hidden bg-ink/5">
                    <img
                      src={p.image}
                      alt={`${p.title} coaching pathway`}
                      loading="lazy"
                      className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                    />
                  </div>
                </div>
              </Link>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
}
